<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Supplier') : $t('New Supplier')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.street"
              label="Street"
              v-validate="'required'"
              required
              data-vv-name="street"
              :error-messages="errors.collect('street')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.city"
              label="City"
              v-validate="'required'"
              required
              data-vv-name="city"
              :error-messages="errors.collect('city')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.zip"
              label="Zip"
              v-validate="'required'"
              required
              data-vv-name="zip"
              type="number"
              :error-messages="errors.collect('zip')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.email"
              label="Email"
              v-validate="'required'"
              required
              data-vv-name="email"
              :error-messages="errors.collect('email')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.phone"
              label="Phone"
              v-validate="'required'"
              required
              data-vv-name="phone"
              :error-messages="errors.collect('phone')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.tax_id"
              label="Tax ID"
              v-validate=""
              required
              data-vv-name="tax_id"
              :error-messages="errors.collect('tax_id')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.website"
              label="Website"
              v-validate=""
              required
              data-vv-name="website"
              :error-messages="errors.collect('website')"
            ></v-text-field>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'supplier.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-supplier-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "supplier.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
